import { FOUR_WEEKS_3999_ONE_WEEK_693_TRIAL_PLAN, FOUR_WEEKS_3999_ONE_WEEK_1386_TRIAL_PLAN, FOUR_WEEKS_3999_ONE_WEEK_1299_TRIAL_PLAN, FOUR_WEEKS_3999_TWO_WEEKS_1399_TRIAL_PLAN, FOUR_WEEKS_3999_TWO_WEEKS_1948_TRIAL_PLAN, FOUR_WEEKS_3999_FOUR_WEEKS_1999_INTRO_PLAN, FOUR_WEEKS_3999_PLAN, TWELVE_WEEKS_7999_TWELVE_WEEKS_3999_INTRO_PLAN, TWELVE_WEEKS_7999_PLAN, FOUR_WEEKS_3527_FOUR_WEEKS_2558_INTRO_PLAN, FOUR_WEEKS_3527_WITHOUT_TRIAL_PLAN, TWELVE_WEEKS_6817_TWELVE_WEEKS_4763_INTRO_PLAN, TWELVE_WEEKS_6817_WITHOUT_TRIAL_PLAN, WEEK_1148_WEEK_693_INTRO_PLAN, FOUR_WEEKS_3527_FOUR_WEEKS_1999_INTRO_PLAN, TWELVE_WEEKS_6817_TWELVE_WEEKS_3999_INTRO_PLAN, WEEK_693_FOUR_WEEKS_3527_INTRO_PLAN, WEEK_1155_FOUR_WEEKS_3527_INTRO_PLAN, FOUR_WEEKS_0999_WITHOUT_TRIAL_PLAN, FOUR_WEEKS_099_WITHOUT_TRIAL_PLAN, TWELVE_WEEKS_1999_WITHOUT_TRIAL_PLAN, TWENTY_FOUR_WEEKS_3999_WITHOUT_TRIAL_PLAN, TWENTY_FOUR_WEEKS_9999_WITHOUT_TRIAL_PLAN } from '../shared/subscription-plans';

const subscriptionMapping = {
    [FOUR_WEEKS_3999_ONE_WEEK_693_TRIAL_PLAN]: {
        name: '1-Week Intro Offer',
        isIntroOffer: true,
        displayOldPrice: '$13.86',
        displayDiscountPercent: 50
    },
    [FOUR_WEEKS_3999_ONE_WEEK_1386_TRIAL_PLAN]: {
        name: '1-Week Intro Offer',
        isIntroOffer: true
    },
    [FOUR_WEEKS_3999_ONE_WEEK_1299_TRIAL_PLAN]: {
        name: '1-Week Intro Offer',
        isIntroOffer: true,
        displayDiscountPercent: 0
    },
    [FOUR_WEEKS_3999_TWO_WEEKS_1399_TRIAL_PLAN]: {
        name: '2-Week Trial',
        isIntroOffer: true,
        displayOldPrice: '$19.48',
        displayDiscountPercent: 28
    },
    [FOUR_WEEKS_3999_TWO_WEEKS_1948_TRIAL_PLAN]: {
        name: '2-Week Trial',
        isIntroOffer: true
    },
    [WEEK_1148_WEEK_693_INTRO_PLAN]: {
        name: '1-Week plan'
    },
    [WEEK_693_FOUR_WEEKS_3527_INTRO_PLAN]: {
        name: '1-Week Intro Offer',
        isIntroOffer: true
    },
    [WEEK_1155_FOUR_WEEKS_3527_INTRO_PLAN]: {
        name: '1-Week Intro Offer',
        isIntroOffer: true
    },
    [FOUR_WEEKS_3999_FOUR_WEEKS_1999_INTRO_PLAN]: {
        name: '4-week plan',
        isPopular: true
    },
    [FOUR_WEEKS_3999_PLAN]: {
        name: '4-week plan',
        isPopular: true
    },
    [FOUR_WEEKS_3527_FOUR_WEEKS_2558_INTRO_PLAN]: {
        name: '4-Week plan',
        isPopular: true
    },
    [FOUR_WEEKS_3527_FOUR_WEEKS_1999_INTRO_PLAN]: {
        name: '4-Week plan',
        isPopular: true
    },
    [FOUR_WEEKS_3527_WITHOUT_TRIAL_PLAN]: {
        name: '4-Week plan',
        isPopular: true
    },
    [FOUR_WEEKS_0999_WITHOUT_TRIAL_PLAN]: {
        name: '4\u2011Week Premium Plan'
    },
    [FOUR_WEEKS_099_WITHOUT_TRIAL_PLAN]: {
        name: '4\u2011Week Premium Plan',
        regularPrice: '$9.99'
    },
    [TWELVE_WEEKS_7999_TWELVE_WEEKS_3999_INTRO_PLAN]: {
        name: '12-week plan'
    },
    [TWELVE_WEEKS_7999_PLAN]: {
        name: '12-week plan'
    },
    [TWELVE_WEEKS_6817_TWELVE_WEEKS_4763_INTRO_PLAN]: {
        name: '12-Week plan'
    },
    [TWELVE_WEEKS_6817_WITHOUT_TRIAL_PLAN]: {
        name: '12-Week plan'
    },
    [TWELVE_WEEKS_6817_TWELVE_WEEKS_3999_INTRO_PLAN]: {
        name: '12-Week plan'
    },
    [TWELVE_WEEKS_1999_WITHOUT_TRIAL_PLAN]: {
        name: '12-Week plan',
        isPopular: true
    },
    [TWENTY_FOUR_WEEKS_3999_WITHOUT_TRIAL_PLAN]: {
        name: '24-Week plan'
    },
    [TWENTY_FOUR_WEEKS_9999_WITHOUT_TRIAL_PLAN]: {
        name: '24-Week plan'
    }
};

const DAYS_IN_MONTH = 30;
const DAYS_IN_WEEK = 7;
const DEFAULT_PRICE_FOR_WEEK_1386 = 1386;
const DEFAULT_PRICE_FOR_WEEK_1155 = 1155;
const DEFAULT_PRICE_FOR_TWO_WEEKS_1948 = 1948;

const getPricePerDay = ({ plan, price, billingPeriod, hasTrial }) => {
    if (plan === WEEK_693_FOUR_WEEKS_3527_INTRO_PLAN && !hasTrial) {
        return Math.round(DEFAULT_PRICE_FOR_WEEK_1155 / DAYS_IN_WEEK);
    }

    if (billingPeriod.unit && billingPeriod.unit === 'week') {
        return Math.round(price / (DAYS_IN_WEEK * Number(billingPeriod.value)));
    }

    return Math.round(price / DAYS_IN_MONTH);
};

const toFixedNumber = value => {
    return Number.parseFloat(value || 0).toFixed(2) || '';
};

const getDiscountPrice = ({ plan, trial, price }) => {
    if (plan === FOUR_WEEKS_3999_ONE_WEEK_693_TRIAL_PLAN) {
        return `$${toFixedNumber((DEFAULT_PRICE_FOR_WEEK_1386 - trial.price) / 100)}`;
    }

    if (plan === WEEK_693_FOUR_WEEKS_3527_INTRO_PLAN) {
        return `$${toFixedNumber((DEFAULT_PRICE_FOR_WEEK_1155 - trial.price) / 100)}`;
    }

    if (plan === FOUR_WEEKS_3999_TWO_WEEKS_1399_TRIAL_PLAN || plan === FOUR_WEEKS_3999_TWO_WEEKS_1948_TRIAL_PLAN) {
        return `$${toFixedNumber((DEFAULT_PRICE_FOR_TWO_WEEKS_1948 - trial.price) / 100)}`;
    }

    return trial ? `$${toFixedNumber((price - trial.price) / 100)}` : 0;
};

const getBillingPeriod = ({ plan, trial, billingPeriod }) => {
    if (plan === FOUR_WEEKS_3999_ONE_WEEK_693_TRIAL_PLAN || plan === WEEK_693_FOUR_WEEKS_3527_INTRO_PLAN || plan === WEEK_1155_FOUR_WEEKS_3527_INTRO_PLAN || plan === FOUR_WEEKS_3999_TWO_WEEKS_1399_TRIAL_PLAN || plan === FOUR_WEEKS_3999_TWO_WEEKS_1948_TRIAL_PLAN) {
        return trial.billingPeriod;
    }

    return billingPeriod;
};

const getSummaryPriceValue = ({ plan, price }) => {
    if (plan === FOUR_WEEKS_3999_ONE_WEEK_693_TRIAL_PLAN) {
        return DEFAULT_PRICE_FOR_WEEK_1386;
    }

    if (plan === WEEK_693_FOUR_WEEKS_3527_INTRO_PLAN) {
        return DEFAULT_PRICE_FOR_WEEK_1155;
    }

    if (plan === FOUR_WEEKS_3999_TWO_WEEKS_1399_TRIAL_PLAN || plan === FOUR_WEEKS_3999_TWO_WEEKS_1948_TRIAL_PLAN) {
        return DEFAULT_PRICE_FOR_TWO_WEEKS_1948;
    }

    return price;
};

const getSummaryPrice = subscriptionData => {
    return `$${toFixedNumber(getSummaryPriceValue(subscriptionData) / 100)}`;
};

const getSummaryPricePerDay = subscriptionData => {
    return getPricePerDay({
        plan: subscriptionData.plan,
        price: getSummaryPriceValue(subscriptionData),
        billingPeriod: getBillingPeriod(subscriptionData),
        hasTrial: Boolean(subscriptionData.trial)
    });
};

const subscriptionPlanMapper = {
    getPlanName(planId) {
        return subscriptionMapping[planId]?.name ?? '';
    },

    toDomain(subscriptionData) {
        const data = subscriptionMapping[subscriptionData.plan];

        if (!data) {
            return null;
        }

        return {
            ...data,
            price: `$${toFixedNumber(subscriptionData.price / 100)}`,
            doubledPrice: `$${Math.round(subscriptionData.price / 100 * 2).toFixed(2)}`,
            discountPrice: getDiscountPrice(subscriptionData),
            pricePerDay: getPricePerDay(subscriptionData),
            billingPeriod: subscriptionData.billingPeriod,
            summaryBillingPeriod: getBillingPeriod(subscriptionData),
            summaryPrice: getSummaryPrice(subscriptionData),
            summaryPricePerDay: getSummaryPricePerDay(subscriptionData),
            plan: subscriptionData.plan,
            trialDuration: subscriptionData.trial ? subscriptionData.trial.billingPeriod.value : null,
            trial: subscriptionData.trial
                ? {
                    ...subscriptionData.trial,
                    price: `$${toFixedNumber(subscriptionData.trial.price / 100)}`,
                    pricePerDay: getPricePerDay({ plan: subscriptionData.plan, price: subscriptionData.trial.price, billingPeriod: subscriptionData.trial.billingPeriod, hasTrial: true })
                }
                : null
        };
    }
};

export {
    subscriptionPlanMapper
};
